export default __webpack_public_path__ + "static/media/16.ba00c7b4.png";